import { render, staticRenderFns } from "./WarmUp2-2.vue?vue&type=template&id=89cb353e&"
import script from "./WarmUp2-2.vue?vue&type=script&lang=js&"
export * from "./WarmUp2-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports